// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8040":"8386459f","9576":"12d16bcb"}[chunkId] + ".chunk.css";
};